export function separateErrorMessages(errorMessage) {
  const splitErrorMessagesArray = errorMessage?.split("|");
  return splitErrorMessagesArray;
}
